"use client";

import InternalServerError from "@/components/global/ErrorComponents/InternalServerError";
import ControlNavFooter from "@/templates/ControlNavFooter";

import { useTranslation } from "../i18n/client";

/* import ErrorComponent from "@/components/global/ErrorAndSplashScreenComponents/ErrorComponents/ErrorComponent"; */

const domain = process.env.NEXT_PUBLIC_NEXTAUTH_URL || "https://www.gother.com";

export default function ErrorCustom({
  status = 500,
  error,
  reset,
}: {
  status?: number | string;
  error?: Error & { digest?: string };
  reset?: () => void;
}) {
  const { t } = useTranslation("error");

  const handleAction = () => {
    if (reset && typeof reset === "function") {
      reset();
    } else {
      window.location.href = "/";
    }
  };

  const wait = setInterval(() => {
    const hasTitle = document.getElementsByTagName("title")[0];
    if (!hasTitle) {
      const title = document.createElement("title");
      if (title) {
        const code = status ?? 500;
        title.textContent = `${t(`error${code}.text1`)}`;
        document.head.appendChild(title);
        clearInterval(wait);
      }
    }
  }, 500);

  const waitToRouteHomePage = setInterval(() => {
    if (domain === "https://www.gother.com") {
      handleAction();
    }
    clearInterval(waitToRouteHomePage);
  }, 1500);

  return (
    <div>
      <div className="my-30 mx-auto flex justify-center">
        <ControlNavFooter />
        <InternalServerError onAction={handleAction} />
      </div>
    </div>
  );
}
